<template>
<div>
<ContentOverlay ></ContentOverlay>

<template v-if="!is_authorized">
<div class="content_card" >
<div class="grid">
<div class="col-12  ">

<div class="content_card_content sticky_panel hide_on_mobile">
<h3 class=" text-primary mt-0">Bu Proje İçin Yetkili Değilsiniz</h3>

</div>
</div>
</div>
</div>
</template>



<div class="content_card" v-if="item">





<div class="grid">





<!--sidebar-->
<ItemSidebar :name="getTheTranslation($store.state.projects.project,'translation')" 
:brand="$store.state.projects.project.brand"
:flowcount="flowcount"
:suppliercount="suppliercount"
></ItemSidebar>
<!--sidebar-->











<div class="col-12 md:col-10">
<div class="content_card_content">
<TabNavigation :tabs="tabs"></TabNavigation>

<router-view></router-view>

</div>
</div>

</div>




</div>
<SupplierUploadDialog></SupplierUploadDialog>
 </div> 
</template>

<script>
export default {

  name: 'Project',

  data () {
    return {
      item:null,
      is_authorized:true,
      tabs: [
          {
              title: 'durum',
              icon: 'chart-line',
              route: 'status',
          },
          {
              title: 'genel',
              icon: 'list',
              route: 'general',
          },
          {
              title: 'proje_periyodlari',
              icon: 'calendar',
              route: 'periods',
          },
          {
              title: 'suppliers',
              icon: 'globe',
              route: 'suppliers',
          },
          {
              title: 'ceviriler',
              icon: 'info-circle',
              route: 'translations',
          },      
          {
              title: 'akislar',
              icon: 'refresh',
              route: 'flows',
          },
          {
              title: 'otomasyon',
              icon: 'cog',
              route: 'conditions',
          },
      ],

    }
  },
  computed:{
    flowcount()
    {
      return this.$store.state.projects.flows.length
    },
    suppliercount()
    {
      return this.$store.state.projects.suppliers.length
    },
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',1) 
    this.getData()
    this.checkTabName(this.tabs)
  },
  methods:{
    async checkNonconformities()
    {
      console.log("checkNonconformities")
      let flows = await this.generalApiGetWithoutLoader("project_flows/"+this.$route.params.id)
      for (let i = 0; i < flows.length; i++)
      {
        if(flows[i].type=="verification" || flows[i].type=="audit")
        {
          let the_obj = await {
            title:"uygunsuzluklar",
            icon: 'exclamation-circle',
            route: 'project_nonconformities',
          }
          await this.tabs.push(the_obj)
          break
        }
      }
    },
  	async getData()
    {
        if(this.$store.state.auth.userroles.includes("brand"))
        {
          let is_authorized = await this.generalApiGetWithoutLoader("brand/is_brand_contact_authrorized/"+this.$route.params.id)
          if(is_authorized===0)
          {
            this.is_authorized = false
            return 
          }
        }

        this.item = await this.generalApiGet("project/"+this.$route.params.id)
        await this.checkNonconformities()
        console.log(this.item)
        await this.$store.dispatch('projects/setProject',this.item) 

        /*
        let suppliers = await this.generalApiGetWithoutLoader("project/all_suppliers/"+this.$route.params.id)
        let flows = await this.generalApiGetWithoutLoader("project_flows/"+this.$route.params.id)
        await this.$store.dispatch('projects/setSuppliers',suppliers)
        await this.$store.dispatch('projects/setFlows',flows) 
        */
        
        for(let tab of this.tabs)
        {
          tab.route = await "/"+this.$store.state.auth.user.uuid+"/project/"+this.$route.params.id+"/"+tab.route
        }
    }
  }
};
</script>

<style lang="css" scoped>
</style>